import { render, staticRenderFns } from "./NewStudioImage.vue?vue&type=template&id=4000aa9b&scoped=true&"
import script from "./NewStudioImage.vue?vue&type=script&lang=js&"
export * from "./NewStudioImage.vue?vue&type=script&lang=js&"
import style0 from "./NewStudioImage.vue?vue&type=style&index=0&id=4000aa9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4000aa9b",
  null
  
)

export default component.exports